import { render, staticRenderFns } from "./AdultCommunityAcquired.vue?vue&type=template&id=50795d89&scoped=true&"
import script from "./AdultCommunityAcquired.vue?vue&type=script&lang=js&"
export * from "./AdultCommunityAcquired.vue?vue&type=script&lang=js&"
import style0 from "./AdultCommunityAcquired.vue?vue&type=style&index=0&id=50795d89&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50795d89",
  null
  
)

export default component.exports